
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/redirect",
      function () {
        return require("private-next-pages/auth/redirect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/redirect"])
      });
    }
  